import { Component } from '@angular/core';
import Swiper from "swiper";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";
import { NgOptimizedImage } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-tab-content1',
    imports: [NgOptimizedImage],
    templateUrl: './tab-content1.component.html',
    styleUrl: './tab-content1.component.scss'
})
export class TabContent1Component {
    assetsCDNUrl = environment.assetsCDNUrl;
    activeTabIndex: number = 0; // The index of the active tab

    ngAfterViewInit() {
        if (typeof window != "undefined") {
            setTimeout(() => {
                this.loadSlider();
            }, 500);
        }
    }

    // Load Slider
    loadSlider() {
        if (window.innerWidth < 992) {
            new Swiper("#map-slider", {
                modules: [Navigation, Pagination, EffectFade, Autoplay],
                autoplay: false,
                loop: false,
                slidesPerView: 3,
                spaceBetween: 10,
                pagination: {
                    clickable: true,
                    el: ".swiper-map-pagination",
                },
                breakpoints: {
                    320: {
                        slidesPerView: 3,
                    },
                    768: {
                        slidesPerView: 5.5,
                    },
                },
            });
        }
    }

    selectTab(index: number): void {
        this.activeTabIndex = index;
    }

    data = {
        heading: "Supporting You, <u>Across India</u>",
        description: "<p>Operating nationwide to provide seamless wealth solutions.</p>",

        items: [
            {
                title: 'Mumbai',
                tabIcon: '/assets/images/locations/mumbai.svg',
                description: '<p>Shriram Wealth Limited, The Capital, A wing, 1st Floor, Unit No. 110, G Block, Bandra Kurla Complex, Bandra (East), Mumbai – 400 051</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/mumbai_maharashtra_map.svg',
                cardIcon: '/assets/images/locations/mumbai-bw.svg'
            },
            {
                title: 'Delhi',
                tabIcon: '/assets/images/locations/delhi.svg',
                description: '<p>Shriram Wealth Limited, 409, Southern Park, Saket district centre, Saket, New Delhi </p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/delhi_map.svg',
                cardIcon: '/assets/images/locations/delhi-bw.svg'
            },
            {
                title: 'Gurugram',
                tabIcon: '/assets/images/locations/gurugram.svg',
                description: '<p>Shriram Wealth Limited, Seva corporate park, Unit no 201A, M.G road, DLF phase 2, sector 25, Gurugram, Haryana – 122002</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/gurugram_haryana_map.svg',
                cardIcon: '/assets/images/locations/gurugram-bw.svg'
            },
            {
                title: 'Bengaluru',
                tabIcon: '/assets/images/locations/bengaluru.svg',
                description: '<p>Shriram Wealth Limited, 2nd Floor, TS Towers, Coffee Day Square, Vittal Mallya Rd, near Cubbon Park, Bengaluru 560001.</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/bengaluru_karnataka_ map.svg',
                cardIcon: '/assets/images/locations/bengaluru-bw.svg'
            },
            {
                title: 'Hyderabad',
                tabIcon: '/assets/images/locations/hyderabad.svg',
                description: '<p>Shriram Wealth Limited, 11th Floor, Rajapushpa Summit, Nanakramguda Village, Serillingapally mandal, Rangareddy District, Financial District, Hyderabad, Telangana Pin: 500032</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/hyderabad_telangana_map.svg',
                cardIcon: '/assets/images/locations/hyderabad-bw.svg'
            },
            {
                title: 'Chennai',
                tabIcon: '/assets/images/locations/chennai.svg',
                description: '<p>Shriram Wealth Limited, 1st Floor, No. 221, Royapettah High Road, Luz, Mylapore, Chennai, Tamilnadu Pin: 600004</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/chennai_tamilnadu_map.svg',
                cardIcon: '/assets/images/locations/chennai-bw.svg'
            },
            {
                title: 'Kolkata',
                tabIcon: '/assets/images/locations/kolkata.svg',
                description: '<p>Shriram Wealth Limited, 2nd floor, J B House, 2. Upper Wood Street, Kolkata: WB Pin: 700016</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/kolkata_west_bengal_map.svg',
                cardIcon: '/assets/images/locations/kolkata-bw.svg'
            },

            {
                title: 'Ahmedabad',
                tabIcon: '/assets/images/locations/ahmedabad.svg',
                description: '<p>Shriram Wealth Limited, C-808, The First, Beside ITC Narmada, Keshav Baug, Satellite, Ahmedabad</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/ahmedabad_gujarat_map.svg',
                cardIcon: '/assets/images/locations/ahmedabad-bw.svg'
            },
            {
                title: 'Pune',
                tabIcon: '/assets/images/locations/pune.svg',
                description: '<p>Shriram Wealth Limited, Park Plaza, 9th floor Ganeshkhind Rd, Akashvani Rashtriya Film Sangrahalay Quarters, Model Colony, Shivajinagar, Pune, Maharashtra 411016</p> <p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/pune_maharashtra_map.svg',
                cardIcon: '/assets/images/locations/pune-bw.svg'
            },
            {
                title: 'Nagpur',
                tabIcon: '/assets/images/locations/Nagpur_bg.svg',
                description: '<p>Shriram Wealth Limited, 7th Floor, Shreeji Park, 19, Kachipura, Ramdaspeth, Nagpur - 440010</p> <p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/nagpur_maharashtra_map.svg',
                cardIcon: '/assets/images/locations/Nagpur.svg'
            },
            {
                title: 'Lucknow',
                tabIcon: '/assets/images/locations/lucknow-dot.svg',
                description: '<p>Shriram Wealth Limited, C/o Shriram Finance Limited, 1st Floor, E-Block, Suraj Deep Complex, Jopling Road, Near Dainik Jagran, Chauraha, Lucknow – 226001, Uttar Pradesh</p> <p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/lucknow_uttar_pradesh_map.svg',
                cardIcon: '/assets/images/locations/lucknow.svg'
            },
            {
                title: 'Vadodara',
                tabIcon: '/assets/images/locations/vadodara-dot.svg',
                description: '<p>Shriram Wealth Limited, C/o Shriram Finance Limited, 301, 3rd Floor, Kanha Capital, R C Dutt Road, Alkapuri, Vadodara - 390007, Gujarat</p> <p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/vadodara_gujarat_map.svg',
                cardIcon: '/assets/images/locations/vadodara.svg'
            },
            {
                title: 'Bhopal',
                tabIcon: '/assets/images/locations/bhopal-dot.svg',
                description: '<p>Shriram Wealth Limited, C/o Shriram Life Insurance Company Limited, 2nd Floor, Guru Arcade, Plot No. 155, Above IDFC First Bank, MP Nagar, Zone – 1, Bhopal – 462011, Madhya Pradesh</p><p>Toll-free Number: <a href="tel:18002683996" title="18002683996">18002683996</a><br><span class="block !text-14 !mb-[14px]">(Available from 9am-6pm on all business days)</span> Email: <a href="mailto:support@shriramwealth.com" title="support@shriramwealth.com">support@shriramwealth.com</a></p>',
                mapImage: '/assets/images/map/bhopal_madhya-pradesh_map.svg',
                cardIcon: '/assets/images/locations/bhopal.svg'
            },
        ]
    }

}
